module.exports = __webpack_public_path__ + "static/media/bullseye-arrow.42615158.svg";